import { Chip, useTheme } from "@mui/material";
import { SlidersHorizontalIcon } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	summary: string;
	onClick: () => void;
	"data-testid"?: string;
};

export const ListFilterChip: FC<Props> = ({
	summary,
	onClick,
	"data-testid": dataTestId,
}) => {
	const { t } = useResource();
	const { iconSize } = useTheme();

	return (
		<Chip
			variant="filter"
			color={summary ? "info" : undefined}
			icon={<SlidersHorizontalIcon size={iconSize.xs} />}
			label={
				summary
					? t(Resources.Common.ListBar.filterChipActive, { summary })
					: t(Resources.Common.ListBar.filterChip)
			}
			data-testid={dataTestId}
			onClick={onClick}
		/>
	);
};
